module.exports = __webpack_public_path__ + "img/Card Pack Set.d949eda4.png";